const component = "confirmation-dialog";

export const confirmationDialog = {
  component,
  icon: `${component}/danger-icon`,
  title: `${component}/title`,
  subtitle: `${component}/subtitle`,
  submitButton: `${component}/submit-button`,
  cancelButton: `${component}/cancel-button`,
};
